(() => {
  if (customElements.get("product-card")) {
    return;
  }

  class ProductCard extends HTMLElement {
    constructor() {
      super();

      this.variantsSelect = this.querySelector("[data-product-select]");
      this.swatches = this.querySelectorAll("[data-swatches] input");
      this.media = this.querySelector("[data-product-media]");
      this.form = this.querySelectorAll(".product-quickshop form");

      this.mobileProductForm = this.querySelectorAll(
        ".product-menu-quickadd form",
      );
      this.mobileProductForm.forEach((form) => {
        form.addEventListener("submit", this.onSubmit.bind(this));
      });

      this.cartDrawer = document.querySelector("cart-drawer");
      this.quickviewTemplate = document.querySelector("#product-quickview");
      this.productTitle = this.dataset.productTitle;
      this.productId = this.dataset.productId;

      if (this.variantsSelect) {
        this.variantsSelect.addEventListener(
          "change",
          this.onVariantChange.bind(this),
        );
      }

      this.form &&
        this.form.forEach((form) => {
          form.addEventListener("submit", this.onSubmit.bind(this));
        });
    }

    connectedCallback() {
      const colorSlider = this.querySelector(".product-colors-splide");
      if (!colorSlider) return;

      function getAutoPerPage(container) {
        const track = container.querySelector(".splide__track");
        const swatch = container.querySelector(".splide__slide");
        if (!swatch) return 1;

        const containerWidth = track.clientWidth;
        const swatchWidth = swatch.offsetWidth;

        return Math.floor(containerWidth / swatchWidth) || 1;
      }
      const perPage = getAutoPerPage(colorSlider);

      const track = colorSlider.querySelector(".splide__track");
      const count = parseInt(colorSlider.dataset.productCount, 10);

      if (track.scrollWidth > track.clientWidth || count > 10) {
        const splide = new Splide(colorSlider, {
          perPage: 10,
          fixedWidth: '24px',
          width: 'calc(24px * 10 + 32px)',
          arrows: true,
          pagination: false,
          padding: '2px',
          omitEnd: true,
          perMove: 5,
          gap: "0",
          drag: true,
          snap: true,
          arrowPath: "M5.29274 3.79274C5.68317 3.40232 6.31626 3.40252 6.70681 3.79274L13.0711 10.157C13.4616 10.5475 13.4616 11.1805 13.0711 11.5711L6.70681 17.9353C6.31626 18.3256 5.68317 18.3257 5.29274 17.9353C4.90232 17.5449 4.90252 16.9118 5.29274 16.5213L10.95 10.864L5.29274 5.20681C4.90252 4.81626 4.90232 4.18317 5.29274 3.79274Z",
          breakpoints: {
            390: {
              perPage: 4,
              perMove: 2,
              width: 'calc(24px * 4 + 25px)',
            },
            576: {
              perPage: 6,
              perMove: 3,
              width: 'calc(24px * 6 + 25px)',
            },
            768: {
              perPage: 8,
              perMove: 4,
              width: 'calc(24px * 8 + 25px)',
            },
            1024: {
              perPage: perPage,
              perMove: 5,
              width: '100%',
              arrows: false
            }
          }
        })

        splide.mount()
      }
      window.disableParentSliderDrag = false;
      ["touchstart", "mousedown"].forEach((event) => {
        track.addEventListener(event, () => {
          window.disableParentSliderDrag = true;
        });
      });

      ["touchend", "mouseup", "mouseleave"].forEach((event) => {
        track.addEventListener(event, () => {
          window.disableParentSliderDrag = false;
        });
      });
    }

    onVariantChange(event) {
      const selectedOption = event.target.selectedOptions[0];

      this.querySelectorAll("[data-product-link]").forEach((link) => {
        link.setAttribute("href", `${this.dataset.url}${selectedOption.value}`);
      });

      if (
        !selectedOption.dataset.imageSrc ||
        !selectedOption.dataset.imageSrcset
      ) {
        return;
      }

      this.media.classList.remove("has-hover");
      this.media.querySelector("[data-secondary-image]").style.display = "none";
      this.media.querySelector("[data-primary-image]").src =
        selectedOption.dataset.imageSrc;
      this.media.querySelector("[data-primary-image]").srcset =
        selectedOption.dataset.imageSrcset;
    }

    onSubmit(event) {
      event.preventDefault();

      const submitter = event.target.querySelector('[type="submit"]');
      const dispatchSubmit = submitter.hasAttribute("data-url");

      if (!dispatchSubmit) {
        this.addItemToCart(event.target);

        return;
      }

      if (
        window.modals &&
        window.modals[`Product-Quickview-${this.productId}`]
      ) {
        const quickview = window.modals[`Product-Quickview-${this.productId}`];

        this.attachQuickview(submitter, quickview);

        return;
      }

      fetch(`${submitter.dataset.url}&variant=${this.variantsSelect.value}`)
        .then((response) => response.text())
        .then((responseText) => {
          this.buildQuickView(submitter, responseText);
        });
    }

    buildQuickView(submitter, responseText) {
      const productDetails = new DOMParser()
        .parseFromString(responseText, "text/html")
        .querySelector("[data-product-details]");
      const productFeaturedMedia = Array.from(
        new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelectorAll("[data-product-media]"),
      ).filter(
        (media) =>
          media.children[0].tagName.toLowerCase() !== "modal-opener" &&
          media.children[0].tagName.toLowerCase() !== "deferred-media",
      );
      const quickview = this.quickviewTemplate.content
        .cloneNode(true)
        .querySelector(".product-quickview");

      quickview.id = `${quickview.id}${this.productId}`;
      quickview.querySelectorAll("[data-modal-close]").forEach((element) => {
        element.id = `${element.id}${this.productId}`;
      });

      if (quickview.querySelector('[role="dialog"]').ariaLabel) {
        quickview.querySelector('[role="dialog"]').ariaLabel = quickview
          .querySelector('[role="dialog"]')
          .ariaLabel.replace("{{ product_title }}", this.productTitle);
      }

      productFeaturedMedia.forEach((media, index) => {
        if (media.children[0].className == "product-model-info") {
          media.children[0].style.display = "none";
        }

        media.children[0].setAttribute("data-product-quickview-media", "");

        if (index === 0) {
          return;
        }

        media.children[0].style.display = "none";
      });
      quickview.querySelector("[data-media-wrapper]").innerHTML = Array.from(
        productFeaturedMedia,
      )
        .map((media) => media.innerHTML)
        .join("");
      quickview.querySelector("[data-details-wrapper]").innerHTML =
        productDetails.innerHTML;

      this.attachQuickview(submitter, quickview);
    }

    attachQuickview(submitter, quickview) {
      document.body.append(quickview);
      setTimeout(() => {
        quickview.show(submitter);
      }, 1);
    }

    addItemToCart(menuForm) {
      if (!this.cartDrawer) {
        this.form && this.form.submit();

        return;
      }

      const config = fetchConfig("javascript");
      config.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config.headers["Content-Type"];

      var inputForm = this.form;
      if (menuForm) {
        inputForm = menuForm;
      }

      const formData = new FormData(inputForm);
      formData.append(
        "sections",
        this.cartDrawer.getSectionsToRender().map((section) => section.id),
      );
      formData.append("sections_url", window.location.pathname);
      config.body = formData;

      this.cartDrawer.setActiveElement(document.activeElement);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            window.console.error(response.status);

            return;
          }

          this.cartDrawer.handleAddedItem(response);
        })
        .catch((error) => {
          window.console.error(error);
        });
    }
  }

  customElements.define("product-card", ProductCard);
})();
